// @flow
import {combineReducers} from 'redux';
import {gameReducer} from './game';
import type {TGameState} from './game';

const reducers = {
    game: gameReducer,
};

type TGameModuleState = {
    game: TGameState,
};

const gameModuleReducer = combineReducers(reducers);
export {gameModuleReducer};
export type {TGameModuleState};
